import { getMember } from '@wix/ambassador-members-v1-member/http';
import { Set } from '@wix/ambassador-members-v1-member/types';
import { withCancelToken } from '@wix/form-http-essentials';
export async function getMemberContactData(options) {
    const { memberId, httpClient, signal } = options;
    if (!memberId) {
        return undefined;
    }
    try {
        // eslint-disable-next-line error-handler/require-http-error-handler
        const response = await httpClient.request(withCancelToken(getMember({
            id: memberId,
            fieldsets: [
                Set.FULL
            ]
        }), signal, httpClient));
        const member = response?.data?.member;
        if (!member) {
            return undefined;
        }
        const { contact } = member;
        const email = member.loginEmail?.trim() || contact?.emails?.[0]?.trim();
        const phone = contact?.phones?.[0]?.trim();
        const firstName = contact?.firstName?.trim();
        const lastName = contact?.lastName?.trim();
        return {
            firstName: firstName || undefined,
            lastName: lastName || undefined,
            email: email || undefined,
            phone: phone || undefined
        };
    } catch  {
        return undefined;
    }
}

//# sourceMappingURL=get-member-contact.js.map